import PropTypes from 'prop-types'
import React from 'react'
import { Column, Logo, Title, Wrapper } from './PartnerBody.style'

const PartnerBody = ({ title, logo, children }) => (
  <Wrapper>
    <Column>
      <Title>{title}</Title>
      {children}

    </Column>
    <Column><Logo src={logo} alt={title} /></Column>
  </Wrapper>
)

PartnerBody.propTypes = {
  children: PropTypes.node.isRequired,
  logo: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
}

export default PartnerBody
